import React from 'react'
import { Link } from 'react-router-dom'
export default function TestLinks() {
  return (
    <div>
      <Link className='d-block' to="/home/readandselect/">Read and Select Questions</Link>
            <Link className='d-block' to="/home/readandcomplete/">Read and Complete Questions</Link>
            <Link className='d-block' to="/home/listenandtype/">Listen and Type Questions</Link>
            <Link className='d-block' to="/home/readaloud/">Read Aloud Questions</Link>
            <Link className='d-block' to="/home/interactivereading/">Interactive Reading</Link>
            <Link className='d-block' to="/home/readthenwrite/">Read Then Write</Link>
            <Link className='d-block' to="/home/readthenspeak/">Read Then Speak</Link>
            <Link className='d-block' to="/home/listenthenspeak/">Listen Then Speak</Link>
            <Link className='d-block' to="/home/writeaboutphoto/">Write About Photo</Link>
            <Link className='d-block' to="/home/speakaboutphoto/">Speak About Photo</Link>
            <Link className='d-block' to="/home/interactivelistening/">Interactive Listening </Link>

    </div>
  )
}
